import React from 'react'
import { ReactComponent as AudiencePeople } from '../images/icons/audience_people.svg'
import { ReactComponent as CalendarIcon } from '../images/icons/icon_calendar.svg'
import { ReactComponent as EmailIcon } from '../images/icons/icon_email.svg'
import { User } from '../lib/types/User'
import dayjs from 'dayjs'

type Props = {
  user: User | undefined
}

export default function PersonalInfoCard({ user }: Props): JSX.Element {
  return (
    <div className={'font-Spartan flex flex-row justify-between border-2 p-5 rounded-lg'}>
      <div className={'flex items-center gap-5'}>
        <AudiencePeople className={'stroke-black'} />
        <div className={'flex flex-col gap-2'}>
          <span className={'font-normal text-sm text-web-gray'}>Full Name</span>
          <span className={'font-bold text-blue-primary text-sm'}>
            {user?.first_name} {user?.last_name}
          </span>
        </div>
      </div>
      <div className={'flex items-center gap-5'}>
        <EmailIcon stroke={'#121124'} />
        <div className={'flex flex-col gap-2'}>
          <span className={'font-normal text-sm text-web-gray'}>Email</span>
          <span className={'font-bold text-blue-primary text-sm'}>
            {user?.email ?? '-'}
          </span>
        </div>
      </div>
      <div className={'flex items-center gap-5'}>
        <CalendarIcon stroke={'#121124'} />
        <div className={'flex flex-col gap-2'}>
          <span className={'font-normal text-sm text-web-gray'}>Date Joined</span>
          <span className={'font-bold text-blue-primary text-sm'}>
            {user?.created_date ? dayjs(user?.created_date).format('MMM DD, YYYY') : '-'}
          </span>
        </div>
      </div>
      <div className={'flex items-center gap-5'}></div>
    </div>
  )
}
